import React from "react";

const TOS_URL = "https://www.swasthiq.com/terms-of-use";
const PP_URL  = "https://www.swasthiq.com/privacy-policy";

interface Props {
  /** Text that appears before the links, e.g. "By clicking Create Account, you agree to our" */
  prefix?: string;
}

const ConsentBlurb: React.FC<Props> = ({
  prefix = "By continuing, you agree to our",
}) => (
  <p className="text-xs text-slate-400 leading-relaxed">
    {prefix}{" "}
    <a
      href={TOS_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="text-slate-500 underline underline-offset-2 hover:text-slate-700"
    >
      Terms of Use
    </a>
    {" "}and{" "}
    <a
      href={PP_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="text-slate-500 underline underline-offset-2 hover:text-slate-700"
    >
      Privacy Policy
    </a>
    .
  </p>
);

export default ConsentBlurb;
